import { useState } from "react";
import { LEGEND_GROUPS, markerLookMeta, type MarkerLook } from "./markerLook";

/** A miniature of the map's marker — same colour, glyph and pulse — so the
 *  legend shows exactly what the map draws rather than describing it. */
function LegendRow({ look }: { look: MarkerLook }) {
  const meta = markerLookMeta(look);
  return (
    <div className="msl-row">
      <span className={"msl-swatch" + (meta.pulse ? " pulse" : "")} style={{ background: meta.color }} aria-hidden="true">
        <svg viewBox="0 0 24 24" width={10} height={10} fill="#fff"><path d={meta.glyph} /></svg>
      </span>
      <span className="msl-label">{meta.label}</span>
    </div>
  );
}

export default function MapLegend() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className={"msl" + (collapsed ? " collapsed" : "")}>
      <button
        type="button"
        className="msl-toggle"
        onClick={() => setCollapsed((c) => !c)}
        aria-expanded={!collapsed}
      >
        <span>Vehicle status</span>
        <svg viewBox="0 0 24 24" width={14} height={14} fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">
          <path d={collapsed ? "M9 18l6-6-6-6" : "M18 15l-6-6-6 6"} />
        </svg>
      </button>
      {!collapsed && (
        <div className="msl-body">
          {LEGEND_GROUPS.map((g, i) => (
            <div className="msl-group" key={g.heading}>
              {i > 0 && <div className="msl-divider" />}
              <div className="msl-col">
                <span className="msl-heading">{g.heading}</span>
                {g.looks.map((look) => <LegendRow key={look} look={look} />)}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
